// extracted by mini-css-extract-plugin
export default {"root":"ServerError_root__vOgqp","success":"ServerError_success__Y1B7K","error":"ServerError_error__eedFY"};